import React, { Fragment, useState } from 'react';
import { H2, LI, UL, Image } from '../../../../AbstractElements';
import { Col, Input, Label, Row } from 'reactstrap';
import { Apply, ApplyCoupon, Total } from '../../../../Constant';
import { postDataWithToken } from '../../../../Utils/restUtils';
import { toast } from 'react-toastify';
import { postApplyCoupon } from '../../../../CommonUrl';

const ProductPlaceOrder = ({ total, delivery, product, setCouponCode, setDiscountAmount, couponCode }) => {
    const [couponResponce, setCouponResponce] = useState('');

    const couponRequest = async () => {
        const postRequest = { coupon_code: couponCode, amount: total }
        const response = await postDataWithToken(postApplyCoupon, postRequest);
        if (response.data.status) {
            toast.success(response.data.message);
            setCouponResponce(response.data.data)
            const discount = response.data.data?.discountAmount || 0;
            setDiscountAmount(discount);
            setCouponCode(couponCode);
        } else {
            toast.error(response.data.message);
        }
    }
   
    return (
        <Fragment>
            <Col xl="6" sm="12">
                <div className="checkout-details" style={{ backgroundColor: 'rgb(83 70 134 / 19%)' }}>
                    <div className="order-box">
                        <div className="title-box">
                            {
                                product && product.map((item) => {
                                    return (
                                        <div className="d-flex align-items-center justify-content-between gap-3 p-2 ">
                                            {/* IMAGE LEFT */}
                                            <Image
                                                attrImage={{
                                                    className: 'img-fluid img-90',
                                                    src: item.item_image,
                                                    alt: item.item_name
                                                }}
                                            />

                                            {/* NAME + QUANTITY CENTER */}
                                            <div className="ms-3" style={{ flex: 1 }}>
                                                <div>
                                                    <h3 className="mb-1">{item.item_name}</h3>
                                                    {item?.attributes &&
                                                        Object.entries(item?.attributes).map(([key, attr]) => (
                                                            <div key={key} style={{ fontSize: '13px', color: '#666' }}>
                                                                {key}: {attr?.value}
                                                            </div>
                                                        ))}
                                                    <p className="mb-0 text-muted"><b>Quantity: {item.quantity}</b></p>
                                                </div>
                                            </div>

                                            {/* PRICE RIGHT */}
                                            <div className="text-end">
                                                <h4 className="mb-0">${item.item_price}</h4>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="checkbox-title mt-2">
                            <H2>{ApplyCoupon}</H2>
                        </div>
                        <UL attrUL={{ className: 'simple-list qty' }} >
                            <div className="input-group">
                                <Input className="form-control" type="text" placeholder="Enter coupon code" style={{ height: '48px' }} value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
                                <div className="btn btn-primary text-white" onClick={() => couponRequest()}>{Apply}</div>
                            </div>
                        </UL>
                        <UL attrUL={{ className: 'simple-list sub-total' }}>
                            <LI><p>Subtotal <span className="count" style={{ fontSize: '13px' }}>$ {total}</span></p></LI>
                            <LI><p>Discount <span className="count" style={{ fontSize: '13px' }}>$ {couponResponce?.discountAmount || 0}</span></p></LI>
                            <LI><p>Delivery Charge <span className="count" style={{ fontSize: '13px' }}>$ {delivery?.amount}</span></p></LI>
                        </UL>
                        <UL attrUL={{ className: 'simple-list sub-total total' }}>
                            <div className="title-box"></div>
                            <LI>{Total}<span className="count">$ {(
                                Number(total || 0) -
                                Number(couponResponce?.discountAmount || 0) +
                                Number(delivery?.amount || 0)
                            ).toFixed(2)}
                            </span></LI>
                        </UL>
                    </div>
                </div>
            </Col>
        </Fragment >
    );
};
export default ProductPlaceOrder;